/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { Container, Row, Col, Card, CardHeader, CardBody, FormGroup, UncontrolledTooltip, Button, Label, Form } from "reactstrap";
import { Home, Trash2, PlusSquare, FolderPlus, CornerUpLeft, Paperclip } from "react-feather";
import SweetAlert from "sweetalert2";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";

import Breadcrumb from "../../components/common/breadcrumb";
import { handleErrors } from "../../services/handleErrors";
import FileList from "./fileList";
import useFetcher from "../../hooks/useFetcher";
import { fetchFolderById, postFolder } from "../../services/fileManagerService";
import ModalCalendarEvent from "../Calendar/ModalCalendarEvent";
import { useFiles } from "../../hooks/useFiles";
import { BlurSpinner } from "../../components/BlurSpinner";
import { useAuth } from "../../context/AuthContext";
import modulos from "../../mocks/modulos";

function FileManager() {
  const { currentUser } = useAuth();
  const isAdmin = currentUser && currentUser.haveAdminAccess(modulos.FILE_MANAGER);
  const [folderIdSelected, setFolderIdSelected] = useState();
  const [folderListSelected, setFolderListSelected] = useState([]);
  const [folders, isLoadingFolders, , , refreshFolders] = useFetcher(fetchFolderById, [{ entityId: folderIdSelected }]);
  const [foldersHome, setFoldersHome] = useState([]);
  const [filteredFolder, setFilteredFolder] = useState([]);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isUploadingFiles, handleUploadFileButton, saveFiles] = useFiles();
  const [canShowAddFile, setCanShowAddFile] = useState(false);
  const [canShowAddFolder, setCanShowAddFolder] = useState(false);

  const isHomeFolder = (folder) => {
    return folder.isService;
  };

  const handleToggleModal = () => {
    setIsOpenModal(!isOpenModal);
    setSelectedFiles([]);
  };

  const getLastParentFolder = () => {
    if (folderListSelected.length > 0) {
      return folderListSelected[folderListSelected.length - 1];
    }
    return null;
  };

  const getLastParentFolderName = () => {
    const parentFolder = getLastParentFolder();
    if (parentFolder) {
      return parentFolder.name;
    }
    return "";
  };

  const handleConfirmSelectedFiles = (event) => {
    setSelectedFiles(event.target.files);
  };

  const handleClickDeletedFiles = async () => {
    const { value: password } = await SweetAlert.fire({
      title: "Ingrese password",
      input: "password",
      inputPlaceholder: "Ingrese su password",
      inputAttributes: {
        maxlength: 10,
        autocapitalize: "off",
        autocorrect: "off",
      },
      icon: "warning",
      buttons: ["Cancelar", "Ingresar"],
      dangerMode: true,
    });

    if (password && password === "asd123") {
      SweetAlert.fire(`Su password: ${password}`);
    } else {
      SweetAlert.fire("Password incorrecta");
    }
  };

  const goHome = () => {
    setFilteredFolder([...foldersHome]);
    setFolderIdSelected(null);
    setFolderListSelected([]);
  };

  const handleDoubleClick = (folderId) => {
    const selected = filteredFolder.find((f) => f.id === folderId);
    setFolderListSelected([...folderListSelected, selected]);
    if (isHomeFolder(selected)) {
      setCanShowAddFile(false);
      if (isAdmin) {
        setCanShowAddFolder(true);
      }
      setFilteredFolder([...selected.childrens]);
    } else if (selected.id === folderIdSelected) {
      setCanShowAddFile(true);
      setCanShowAddFolder(true);
      refreshFolders();
    } else {
      setCanShowAddFile(true);
      setCanShowAddFolder(true);
      setFolderIdSelected(folderId);
    }
  };

  const isChildrenOfHome = (folder) => {
    if (folder.parentId == null && Number.isInteger(folder.id)) {
      return true;
    }
    return false;
  };

  const goToParent = () => {
    const parentSelected = folderListSelected.pop();
    if (parentSelected) {
      const isHome = isHomeFolder(parentSelected);
      if (isHome) {
        goHome();
        setCanShowAddFile(false);
        setCanShowAddFolder(false);
      } else if (isChildrenOfHome(parentSelected)) {
        if (isAdmin) {
          setCanShowAddFolder(true);
        } else {
          setCanShowAddFolder(false);
        }
        setCanShowAddFile(false);
        const homeFolder = foldersHome.find((folder) => folder.id === parentSelected.servicio);
        if (homeFolder.childrens) {
          setFilteredFolder(homeFolder.childrens);
        }
      } else {
        setCanShowAddFile(true);
        setCanShowAddFolder(true);
        setFolderIdSelected(parentSelected.parentId);
      }
    }
  };

  const updateFolderHomeChildrens = (folderChildrens) => {
    const newFolderHome = [...foldersHome];
    newFolderHome.childrens = folderChildrens;
    setFoldersHome(newFolderHome);
  };

  const createNewFolder = async () => {
    const lastParentFolder = getLastParentFolder();
    const { value: folderName } = await SweetAlert.fire({
      title: "Ingrese nombre de carpeta",
      input: "text",
      inputPlaceholder: "nombre de carpeta",
      confirmButtonColor: "#bf0d3e",
      inputAttributes: {
        maxlength: 60,
        autocapitalize: "off",
        autocorrect: "off",
      },
    });

    if (folderName && folderName.trim().length > 3) {
      if (lastParentFolder) {
        try {
          const { id, servicio, isProtected } = lastParentFolder;
          const folderData = {
            parentId: id,
            name: folderName,
            servicio,
            isProtected,
          };
          if (isHomeFolder(lastParentFolder)) {
            delete folderData.parentId;
          }
          const { message, result } = await postFolder(folderData);
          if (result.id) {
            updateFolderHomeChildrens([...filteredFolder, result]);
            setFilteredFolder([...filteredFolder, result]);
          }
          toast.success(message);
        } catch (error) {
          handleErrors(error, toast.error);
        }
      }
    }
  };

  const castFileDataToFolderData = (listFiles) => {
    const filesCasted = listFiles.map((file) => {
      return {
        id: `${file.id}_file`,
        realId: file.id,
        name: file.originalname,
        mimetype: file.mimetype,
        isFolder: false,
        parentId: file.FileRels.entityId,
        updatedAt: file.updatedAt,
      };
    });
    return filesCasted;
  };

  const uploadFiles = async () => {
    const actualParentFolder = getLastParentFolder();
    try {
      if (selectedFiles.length > 0 && actualParentFolder) {
        try {
          await saveFiles({ entity: "folder", entityId: actualParentFolder.id });
          refreshFolders();
          handleToggleModal();
        } catch (error) {
          let errMsg = "";
          handleErrors(error, (msg) => {
            errMsg = msg;
          });
          toast.error(`Error subiendo los archivos. ${errMsg}`);
        }
      }
    } catch (error) {
      handleErrors(error, toast.error);
    }
  };

  useEffect(() => {
    if (Array.isArray(folders)) {
      setFilteredFolder([...folders]);
      const foldersInHome = folders.filter((f) => f.isService);
      setFoldersHome(foldersInHome);
    } else {
      const childrens = folders.childrens ? folders.childrens : [];
      const files = folders.Files ? folders.Files : [];
      if (files.length > 0) {
        const castedFileFolder = castFileDataToFolderData(files);
        setFilteredFolder([...childrens, ...castedFileFolder]);
      } else {
        setFilteredFolder(childrens);
      }
    }
  }, [folders]);

  return (
    <>
      <Helmet>
        <title>File Manager - Payroll</title>
      </Helmet>
      <Breadcrumb parent="File Manager" title="Payroll" />
      <Container fluid>
        <Row>
          <Col xl="3" className="box-col-6 pr-0">
            <div className="file-sidebar">
              <Card>
                <CardBody>
                  <ul>
                    <li>
                      <Button color="primary" className="btn-block" onClick={goHome}>
                        <Home /> Home
                      </Button>
                    </li>
                    <li>
                      <Button color="primary" id="btnDeleted" className="btn-block btn-light" onClick={handleClickDeletedFiles}>
                        <Trash2 /> Eliminados
                      </Button>
                      <UncontrolledTooltip placement="right" target="btnDeleted">
                        Todos los archivos movidos a la carpeta (Eliminados) serán eliminados definitivamente, luego de 30 días desde que se movieron a la misma.
                      </UncontrolledTooltip>
                    </li>
                  </ul>
                </CardBody>
              </Card>
            </div>
          </Col>
          <Col xl="9" md="12" className="box-col-12">
            <div className="file-content">
              <Card>
                <CardHeader>
                  <div className="media">
                    <div className="media-body text-right">
                      <div className="d-inline-flex">
                        {canShowAddFile && (
                          <Button color="primary" className="m-1" onClick={handleToggleModal}>
                            <PlusSquare /> Agregar archivo
                          </Button>
                        )}
                        {canShowAddFolder && (
                          <Button color="primary" className="m-1" onClick={createNewFolder}>
                            <FolderPlus /> Nueva carpeta
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                </CardHeader>
                {!isLoadingFolders && (
                  <CardBody className="file-manager">
                    <h4 className="mb-3"> Todos los archivos</h4>
                    <div className="row">
                      <Button className="my-3" color="primary" onClick={goToParent} disabled={folderListSelected.length < 1}>
                        <CornerUpLeft /> {getLastParentFolderName()}
                      </Button>
                    </div>
                    <FileList files={filteredFolder} handleDoubleClick={handleDoubleClick} refreshFolders={refreshFolders} />
                  </CardBody>
                )}
              </Card>
            </div>
          </Col>
        </Row>
      </Container>

      <ModalCalendarEvent modalTitle="Subir archivos" handleIsOpenModal={isOpenModal} handleToggleModal={handleToggleModal}>
        <BlurSpinner isLoading={isUploadingFiles}>
          <FormGroup>
            <Form className="p-absolute" style={{ height: "0px", width: "0px", overflow: "hidden" }}>
              <input
                id="upfile"
                type="file"
                onChange={handleConfirmSelectedFiles}
                multiple
                accept="image/jpeg,image/gif,image/png,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              />
            </Form>
            <Label className="col-form-label pt-0 w-100">Adjuntar archivos</Label>
            <Button color="link" size="xs" onClick={handleUploadFileButton}>
              <Paperclip size="24" />
            </Button>
            {selectedFiles.length > 0 ? (
              <div className="normalized_ul">
                <Label className="col-form-label pt-0 w-100">Archivos adjuntos</Label>
                <ul>
                  {Array.from(selectedFiles).map((file) => (
                    <li key={file.name}>{file.name}</li>
                  ))}
                </ul>
                <Button className="mt-3" color="primary" onClick={uploadFiles} disabled={isUploadingFiles}>
                  Subir
                </Button>
              </div>
            ) : (
              <></>
            )}
          </FormGroup>
        </BlurSpinner>
      </ModalCalendarEvent>
    </>
  );
}

export default withRouter(FileManager);
